import React from 'react';
import './YellowErrorMessage.scss';

const YellowErrorMessage = ({ children }) => {
  return (
    <div className="yellow-error-message">
      {children}
    </div>
  );
};

export default YellowErrorMessage; 